import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import MappingElement from '../../components/entity/MappingElement';

const mapStateToProps = createSelector(
  (state, { element }) => element.getComponentProps(state),
  props => props
);

export default connect(mapStateToProps)(MappingElement);